"use client";
import { usePathname } from "next/navigation";
import Header from "@/components/partials/Header";
import Footer from "@/components/partials/Footer";
import FixedFooter from "@/components/partials/FixedFooter";

export default function ClientLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  const pathname = usePathname();
  
  // Ocultar header e footer na página smapplications e congratulations
  const isMarketingCampain = pathname === "/smapplications" || pathname === "/congratulations";

  if (isMarketingCampain) {
    return (
      <div className="min-h-screen bg-gray-50">
        {children}
      </div>
    );
  }

  return (
    <>
      <Header />
      <div className="main-content">
        <div className="page-content pb-20">
          {children}
        </div>
      </div>
      <Footer />
      <FixedFooter />
    </>
  );
}
